import React, { useEffect, useState } from "react";
import "swiper/css";
import { getAllStoreParentCategories, getAllVendorsByCategory } from "../../helper/backend-methods";

import defaultImage from "../../assets/images/mains-logo.png";

export default function BrowseCategorySection() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [vendorLoading, setVendorLoading] = useState(false);

  const _getAllVendorsCategories = async () => {
    try {
      setCategoryLoading(true);

      const response = await getAllStoreParentCategories({ store: 2 });
      const categoryData = response?.data?.Data || [];

      setCategories(categoryData);

      if (categoryData.length > 0) {
        setActiveCategory(categoryData[0].CategoryId);
        setSelectedCategory(categoryData[0]);
        await _getAllVendors(categoryData[0].CategoryId);
      }
    } catch (error) {
      console.error("Error fetching vendors categories:", error);
    } finally {
      setCategoryLoading(false);
    }
  };

  const _getAllVendors = async (id) => {
    try {
      setVendorLoading(true);

      const response = await getAllVendorsByCategory({ categoryId: id });
      setVendors(response?.data?.Data || []);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setVendors([]);
    } finally {
      setVendorLoading(false);
    }
  };

  const handleCategoryChange = async (categoryId) => {
    setActiveCategory(categoryId);

    const category = categories.find((cat) => cat.CategoryId === categoryId);
    setSelectedCategory(category);

    await _getAllVendors(categoryId);
  };

  useEffect(() => {
    _getAllVendorsCategories();
  }, []);

  return (
    <section id="browse-category-section">
      <div className="wrapper">
        <h2 className="browse-category-title">BROWSE BY CATEGORY</h2>

        <div className="browse-category-list">
          {categoryLoading ? (
            <div className="browse-vendors-empty">Loading categories...</div>
          ) : categories.length > 0 ? (
            categories.map((category) => (
              <button
                key={category.CategoryId}
                type="button"
                className={`browse-category-item ${activeCategory === category.CategoryId ? "active" : ""}`}
                onClick={() => handleCategoryChange(category.CategoryId)}
              >
                <span className={`browse-category-image-box ${activeCategory === category.CategoryId ? "active" : ""}`}>
                  <img src={category.CategoryPicture?.Url || defaultImage} alt={category.CategoryName} />
                </span>

                <span className="browse-category-name">{category.CategoryName}</span>
              </button>
            ))
          ) : (
            <div className="browse-vendors-empty">Categories not available.</div>
          )}
        </div>

        <div className="browse-vendors-panel">
          <h3>{selectedCategory?.CategoryName ? `${selectedCategory.CategoryName} Vendors` : "Vendors"}</h3>

          {vendorLoading ? (
            <div className="browse-vendors-empty">Loading vendors...</div>
          ) : vendors.length > 0 ? (
            <div className="browse-vendors-grid">
              {vendors.map((vendor) => (
                <div key={vendor.VendorId} className="browse-vendor-card">
                  <img src={vendor.VendorPicture?.Url || defaultImage} alt={vendor.VendorName} />

                  <h4>{vendor.VendorName}</h4>

                  <p>{vendor.VendorDescription || "No description available."}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="browse-vendors-empty">Vendors not available.</div>
          )}
        </div>
      </div>
    </section>
  );
}
